import {
  ITextData,
  ITextDataBanner,
  ITotalSum,
} from 'app/services/api5-service/api.interface';

import { TypedControlBase } from '../typed-controls';

export interface TotalSumControl extends TypedControlBase {
  readonly control: ITotalSum;
  readonly type: 'totalsum';
}

/**
 * Check that input control meta is cart meta
 *
 * @param control - control metadata
 */
export function isTotalSumControl(
  control: ITextData | ITextDataBanner | ITotalSum,
): control is ITotalSum {
  return control.$type === 'cart_total';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 */
export function getTypeControlForTotalSum(control: ITotalSum): TotalSumControl {
  return {
    control,
    type: 'totalsum',
  } as TotalSumControl;
}
